import styles from './WelcomeCommunity.module.css';

function StarIcon() {
    return <svg viewBox="0 0 24 24" fill="currentColor"><polygon points="12 2.5 14.9 8.6 21.5 9.4 16.6 14 17.9 20.6 12 17.3 6.1 20.6 7.4 14 2.5 9.4 9.1 8.6"></polygon></svg>;
}

const SOCIALS = [
    {
        label: 'Instagram',
        href: 'https://www.instagram.com/tb2.health?igsh=MTZyMXAwYTZ6Z2p1Zw==',
        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2.5" y="2.5" width="19" height="19" rx="5"></rect><circle cx="12" cy="12" r="4.2"></circle><circle cx="17.6" cy="6.4" r="1.1" fill="currentColor" stroke="none"></circle></svg>,
    },
    {
        label: 'Facebook',
        href: 'https://www.facebook.com/share/1Cmi3Tn8TD/',
        icon: <svg viewBox="0 0 24 24" fill="currentColor"><path d="M13.5 21v-7h2.5l.5-3h-3V9.2c0-.9.3-1.5 1.6-1.5H16.6V5.1C16.3 5.07 15.4 5 14.4 5c-2.2 0-3.7 1.3-3.7 3.8V11H8.2v3h2.5v7h2.8z"></path></svg>,
    },
    {
        label: 'TikTok',
        href: 'https://www.tiktok.com/@tb2_health?_r=1&_t=ZS-96SbQnBMMNz',
        icon: <svg viewBox="0 0 24 24" fill="currentColor"><path d="M16.6 3c.4 2.1 1.7 3.4 3.9 3.6v2.8c-1.5 0-2.8-.5-3.9-1.3v5.9c0 3.7-2.6 5.9-5.6 5.9-2.9 0-5.5-2.2-5.5-5.4 0-3.4 3-5.8 6.2-5.3v2.9c-1.6-.5-3.3.6-3.3 2.3 0 1.5 1.2 2.6 2.6 2.6 1.5 0 2.7-1.1 2.7-3V3h2.9z"></path></svg>,
    },
];

function WelcomeCommunity() {
    return (
        <section className={styles.community} id="community" data-screen-label="Community">
            <div className={styles.communityInner}>
                <div className={styles.communityHead}>
                    <div className={styles.eyebrow}>The TB2 community</div>
                    <h2>You don't have to do this quietly</h2>
                </div>
                <div className={styles.communityRow}>
                    <div className={`${styles.commCard} ${styles.follow}`}>
                        <h3>Join the TB2 community</h3>
                        <p>You're not doing this alone. Join thousands of members who lean on each other &mdash; sharing wins, showing up on the hard days, and proving that what helps you can help someone else too.</p>
                        <div className={styles.socialRow}>
                            {SOCIALS.map((s) => {
                                const external = s.href !== '#';
                                return (
                                    <a
                                        className={styles.socialBtn}
                                        href={s.href}
                                        target={external ? '_blank' : undefined}
                                        rel={external ? 'noopener noreferrer' : undefined}
                                        aria-label={`TB2 on ${s.label}`}
                                        key={s.label}
                                    >
                                        {s.icon}
                                        {s.label}
                                    </a>
                                );
                            })}
                        </div>
                    </div>
                    <div className={`${styles.commCard} ${styles.review}`}>
                        <div className={styles.tpHead}>
                            <div className={styles.tpBrand}>
                                <span className={styles.tpMark}><StarIcon /></span>
                                <span className={styles.tpWord}>Trustpilot</span>
                            </div>
                            <div className={styles.tpStars}>
                                {[0, 1, 2, 3, 4].map((i) => (
                                    <span className={styles.st} key={i}><StarIcon /></span>
                                ))}
                            </div>
                        </div>
                        <div className={styles.tpScoreLine}>Rated <b>Excellent</b> &middot; <b>4.7</b> out of 5</div>
                        <h3>Tell us how it's going</h3>
                        <p>Your honest review helps someone who's exactly where you were a week ago decide to take their first step.</p>
                        <a className={styles.btnWhite} href="https://www.trustpilot.com/review/tb2.health" target="_blank" rel="noopener noreferrer">Review us on Trustpilot</a>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default WelcomeCommunity;
